document.addEventListener('DOMContentLoaded', function() {
    // 1. Crear e inyectar los estilos CSS para el fondo rojo y el brillo
    const estilos = document.createElement('style');
    estilos.innerHTML = `
        .btn-ofertas-destacadas {
            background-color: #e90400ff !important; /* Color de fondo rojo */
            color: #ffffff !important; /* Texto blanco */
            font-weight: 900;
            border-radius: 4px; /* Bordes ligeramente redondeados (opcional) */
            overflow: hidden; /* Para que el brillo no se salga del botón */
            position: relative; /* Necesario para posicionar el brillo absoluto */
            padding: 4px 12px; /* Un poco de espaciado interno */
            transition: background-color 0.3s ease;
            
            
        }

        /* Asegurar que el span interno herede el color blanco */
        .btn-ofertas-destacadas span {
            color: #ffffff !important; 
        }

        /* Efecto de brillo usando pseudo-elemento */
        .btn-ofertas-destacadas::before {
            content: '';
            position: absolute;
            top: 0;
            left: -150%;
            width: 50%;
            height: 100%;
            background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%);
            transform: skewX(-25deg); /* Inclinación del brillo */
            animation: efecto-brillo 4s infinite; /* Pasa cada 4 segundos */
            pointer-events: none; /* Evita que el brillo interfiera con el clic */
        }

        /* Animación de lado a lado */
        @keyframes efecto-brillo {
            0% { left: -150%; }
            20% { left: 150%; }
            100% { left: 150%; } /* Se queda esperando antes de repetir */
        }
    `;
    document.head.appendChild(estilos);

    // 2. Buscar el enlace <a> que contenga el texto "Ofertas"
    const enlaces = document.querySelectorAll('.header__bottom a span');
    
    enlaces.forEach(enlace => {
        // Usamos textContent y trim() para limpiar espacios en blanco alrededor del texto
        if (enlace.textContent.trim() === 'OFERTAS %') {
            enlace.classList.add('btn-ofertas-destacadas');
        }
    });
});


/* OCULTAR BOTON TIDIO EN MIVILES Y HABILITRA TIDIO EN BARRA DE MENU INFERIOR */
(function () {

  function setupTidio() {

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    /* Ocultar el launcher/burbuja de Tidio en móvil */
    if (isMobile()) {
      window.tidioChatApi.hide();
    }

    /* Cuando el usuario cierra el chat,
       vuelve a ocultarlo en móvil */
    window.tidioChatApi.on('close', function () {
      if (isMobile()) {
        window.tidioChatApi.hide();
      }
    });
  }

  /* Espera a que Tidio esté cargado */
  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', setupTidio);
  } else {
    document.addEventListener('tidioChat-ready', setupTidio);
  }

  /* Botón Chat del menú Hype */
  document.addEventListener('click', function(event) {

    const button = event.target.closest('.open-tidio-chat');

    if (!button) return;

    event.preventDefault();

    if (window.tidioChatApi) {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    }

  });


  /* BLOQUE DESCARGA DE VIDEOS */

  (() => {
    const proteger = (video) => {
      video.setAttribute('controlslist', 'nodownload');
    };

    document.querySelectorAll('video').forEach(proteger);

    new MutationObserver((cambios) => {
      for (const cambio of cambios) {
        for (const nodo of cambio.addedNodes) {
          if (!(nodo instanceof Element)) continue;
          if (nodo.matches('video')) proteger(nodo);
          nodo.querySelectorAll('video').forEach(proteger);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('contextmenu', (evento) => {
      if (evento.target instanceof Element && evento.target.closest('video')) {
        evento.preventDefault();
      }
    });
  })();

  /* Evita brinco al top a # */
document.addEventListener('click', function (evento) {
  if (!(evento.target instanceof Element)) return;
  if (!evento.target.closest('[data-link="#"]')) return;

  evento.preventDefault();
  evento.stopImmediatePropagation();
}, true);


})();